/**************************************************
 * Nombre:       Formulario_Producto_Nombre
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, Title} from "@mui/icons-material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOANUNCIOS} from "../../Constantes";
import IngresoTextoEstilo from "../../Modulo_formularios/Componentes/IngresoTextoEstilo";
import IngresoImagenCropLista from "../../Modulo_formularios/Componentes/IngresoImagenCropLista";

const Formulario_Proyecto = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={2} alto={1}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOANUNCIOS.map((it) => it.nombre)}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} dato={'titulo'} {...props}
                                  requerido={'El titulo es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Parrafo'} dato={'parrafo'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={10} nombre={'Parrafo Complementario'}
                                  dato={'parrafoComplementario'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Puntos Clave</Typography>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoEstilo dato={'puntosClave'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCropLista dato={'imgs'} {...props} />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Proyecto